










































































import { AxiosError } from 'axios';
import { defineComponent, ref, watch } from '@vue/composition-api';

import { ALForm } from '@/common/component.types';
import { ISystemError } from '@/models/error';
import { useUploadHSCode } from '@/composable/hs-codes';

import FormRules from '@/mixins/file-upload-rules';
import { setErrorFromAxiosError } from '@/utils/helpers';

import DragDropFileInput from '../common/DragDropFileInput.vue';
import ErrorAlert from '../common/ErrorAlert.vue';
import ALDialog from '../core/Dialog/ALDialog.vue';

export default defineComponent({
  name: 'HSCodeUploadFileDialog',

  components: { DragDropFileInput, ErrorAlert, ALDialog },

  mixins: [FormRules],

  setup(props) {
    const isDialogActive = ref(false);
    const isFormValid = ref(false);

    const fileUpload = ref<File | null>(null);

    const error = ref<ISystemError | null>(null);

    const formRef = ref<ALForm>();

    watch(isDialogActive, value => {
      if (!value) {
        fileUpload.value = null;
      }
    });

    function clearError() {
      error.value = null;
    }

    function resetFormValidation(): void {
      if (formRef.value) {
        return formRef.value.resetValidation();
      }
    }

    function validateForm(): boolean {
      let valid = false;
      if (formRef.value) {
        valid = formRef.value.validate();
      }
      return valid;
    }

    function close() {
      isDialogActive.value = false;
      clearError();
      resetFormValidation();
    }

    const {
      isLoading,
      mutate: uploadHSCode,
      reset: uploadReset
    } = useUploadHSCode();

    async function uploadHSCodeFileHandler() {
      uploadReset();

      const valid = validateForm();

      if (valid) {
        uploadHSCode(fileUpload.value!, {
          onSuccess: () => {
            fileUpload.value = null;
            close();
          },
          onError: err => {
            error.value = setErrorFromAxiosError(err as AxiosError);
          }
        });
      }
    }

    return {
      // REFS
      formRef,

      // DATA
      isDialogActive,
      isLoading,
      isFormValid,
      fileUpload,
      error,

      // METHODS
      uploadHSCodeFileHandler,
      clearError,
      close
    };
  }
});
